module.exports = __webpack_public_path__ + "img/icon5.6144bca1.svg";